import { Modal, ModalProps } from "antd-v5"
import React, { useRef } from "react"
import Draggable from "react-draggable"
import { twMerge } from "tailwind-merge"

interface Props extends ModalProps {
	childrenClassName?: string
	isDraggable?: boolean
}

const AntdModal: React.FC<Props> = ({
	open,
	onCancel,
	onOk,
	title,
	children,
	childrenClassName = "",
	isDraggable = false,
	...rest
}) => {
	const dragRef = useRef<HTMLDivElement>(null)

	return (
		<Modal
			open={open}
			onOk={onOk}
			onCancel={onCancel}
			title={<div className="modal-drag-handle text-center">{title}</div>}
			{...rest}
			okButtonProps={{
				...rest.okButtonProps,
				style: !rest.okButtonProps?.disabled ? { backgroundColor: "#6366f1" } : {},
			}}
			modalRender={modal =>
				isDraggable ? (
					<Draggable nodeRef={dragRef} handle=".modal-drag-handle">
						<div ref={dragRef}>{modal}</div>
					</Draggable>
				) : (
					modal
				)
			}
		>
			<div className={twMerge("max-h-[67vh] overflow-y-auto", childrenClassName)}>{children}</div>
		</Modal>
	)
}

export default AntdModal
